'use es6';

export var getDesktopPreview = function getDesktopPreview(state) {
  return state.preview.desktop;
};
export var getMobilePreview = function getMobilePreview(state) {
  return state.preview.mobile;
};